module.exports = __webpack_public_path__ + "img/local-caregivers.68d4d4fc.png";